<template>
  <a
    v-if="trimmedEmail"
    :href="`mailto:${trimmedEmail}`"
    :class="button({ variant: 'subtle', size: 'sm', class: props.class })"
    :aria-label="`Email ${trimmedEmail}`"
  >
    <span class="truncate">{{ trimmedEmail }}</span>
    <MailIcon class="size-[1em] shrink-0" aria-hidden="true" />
  </a>
  <template v-else>n/a</template>
</template>

<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import { Mail as MailIcon } from 'lucide-vue-next';
import { button } from '@carvia/theme/lib/cva/button';

const props = defineProps<{
  email?: string | null;
  class?: HTMLAttributes['class'];
}>();

const trimmedEmail = computed(() => props.email?.trim() || '');
</script>
